export const v2ExtendedColors = {
  coolGrey: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#E5E5E5',
    300: '#D4D4D4',
    400: '#A3A3A3',
    500: '#737373',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
    A100: '#F5F5F5',
    A200: '#E5E5E5',
    A400: '#A3A3A3',
    A700: '#404040',
  },
  brandBlue: {
    500: '#9AC3EA',
    600: '#2F5B86',
    700: '#497EB1',
  },
  brandRed: {
    500: '#D52F00',
  },
  brandYellow: {
    500: '#E9AB00',
  },
  brandAmber: {
    400: '#FBBF24',
  },
} as const;
